<div *ngIf="yieldConfig && !hideYield" class="portfolio-yield">
	<dz-toggle-switch
		[toggleOn]="showYield"
		[toggleLabel]="yieldToggleLabel"
		[dcrKeys]="['PDF_GENERATE_YIELD_HEADER', 'PDF_GENERATE_YIELD_HEADER_SCENARIO_ADVISORY_FEE']"
		(click)="toggleYield()"
		custom-tracking
		[track-event]="'pdf-logo-upload:include-yield-toggle:' + (!showYield ? 'on' : 'off')"
	>
	</dz-toggle-switch>
	<label>
		<span
			*ngIf="!disableYield"
			[dcrHTMLKey]="isScenarioAdvisoryFeeEnabled ? 'PROSPECTUS_LABEL_INCLUDE_YIELD_MESSAGE_SCENARIO_ADVISORY_FEE_DEFAULT' : 'PROSPECTUS_LABEL_INCLUDE_YIELD_MESSAGE_DEFAULT'"
			class="text-12 section-header"
		>
			(By default, 12 Month Trailing Yield is not included.<ng-container *ngIf="isScenarioAdvisoryFeeEnabled">
				Yield will be included with Scenario Results if set in the Scenarios tab </ng-container
			>)
		</span>
		<span *ngIf="disableYield" dcrHTMLKey="PROSPECTUS_LABEL_INCLUDE_YIELD_MESSAGE_DISABLED" class="text-12 section-header">
			(By default, 12 month trailing yield is not included. Please consider including less funds in the portfolio to include yield in the output)
		</span>
	</label>

	<div *ngIf="showYield && !isScenarioAdvisoryFeeEnabled" class="yield">
		<section class="margin-bottom-30">
			<label class="ac-checkbox display-inline-flex" for="yieldCheckbox">
				<input
					id="yieldCheckbox"
					name="yieldCheckbox"
					type="checkbox"
					class="form-control"
					[checked]="includeYield"
					(change)="onYieldFlagChange()"
					custom-tracking
					[track-event]="'pdf-logo-upload:include-yield-snapshot-toggle:' + (!includeYield ? 'on' : 'off')"
				/>
				<span dcrHTMLKey="PROSPECTUS_LABEL_INCLUDE_YIELD_MESSAGE_CUSTOM"> Add yield to the Snapshot and Fixed Income Attributes sections of this report.</span>
			</label>
		</section>

		<section *ngIf="showScenarioYield" class="margin-bottom-30">
			<label class="ac-checkbox display-inline-flex" for="scenariosYieldCheckbox">
				<input
					id="scenariosYieldCheckbox"
					name="scenariosYieldCheckbox"
					type="checkbox"
					class="form-control"
					[checked]="includeScenarioYield"
					(change)="onScenarioYieldFlagChange()"
					custom-tracking
					[track-event]="'pdf-logo-upload:include-yield-scenarios-toggle:' + (!includeScenarioYield ? 'on' : 'off')"
				/>
				<span dcrHTMLKey="PROSPECTUS_LABEL_INCLUDE_SCENARIOS_YIELD_MESSAGE_CUSTOM"> Add yield to the Scenarios results in this report.</span>
			</label>
			<section *ngIf="!disableYield" dcrHTMLKey="PROSPECTUS_LABEL_INCLUDE_SCENARIOS_YIELD_MESSAGE_DEFAULT_CUSTOM" class="text-12 scenarios-checkbox">
				(12 month trailing yield will be added to the price movement results of each scenario)
			</section>
			<section *ngIf="disableYield" dcrHTMLKey="PROSPECTUS_LABEL_INCLUDE_SCENARIOS_YIELD_MESSAGE_DISABLED_CUSTOM" class="text-12 scenarios-checkbox">
				(By default, 12 month trailing yield is not included. Please consider including less funds in the portfolio to include yield in the output)
			</section>
		</section>
	</div>
</div>

<section *ngIf="showEmailLink" class="yield-alert">
	<section class="yield-field">
		<section class="warning-background" [ngClass]="{ 'success-background': showAllActionsPerformed }">
			<span class="warning-head orange" [ngClass]="{ 'success-head': showAllActionsPerformed }">
				<ng-container *ngIf="!showAllActionsPerformed; else successIcon">
					<icon class="message-icon" type="exclamation-triangle"></icon>
				</ng-container>
				<ng-template #successIcon> <icon class="message-icon" type="check"></icon> </ng-template>
			</span>
			<section class="warning-content">
				<span *ngIf="(includeYield || includeScenarioYield) && !yieldConfig['inAct33']" dcrHTMLKey="PROSPECTUS_EMAIL_WARNING_MESSAGE_YIELD" class="warning-message text-14">
					To include 12 Month Trailing Yield, this report must be preceded or accompanied by a current prospectus. Investors should read and consider it carefully before
					investing. Please email the prospectus(es) to the client.
				</span>

				<span *ngIf="!includeYield && !includeScenarioYield && yieldConfig['inAct33']" dcrHTMLKey="PROSPECTUS_EMAIL_WARNING_MESSAGE_ACT33" class="warning-message text-14">
					Because the analysis contains 33 Act funds, this report must be preceded or accompanied by a current prospectus. Investors should read and consider it carefully
					before investing. Please email the prospectus(es) to the clients.
				</span>

				<span
					*ngIf="(includeYield || includeScenarioYield) && yieldConfig['inAct33']"
					dcrHTMLKey="PROSPECTUS_EMAIL_WARNING_MESSAGE_YIELD_AND_ACT33"
					class="warning-message text-14"
				>
					To include 12 Month Trailing Yield and 33 Act funds, this report must be preceded or accompanied by a current prospectus. Investors should read and consider it
					carefully before investing. Please email the prospectus(es) to the clients.
				</span>

				<a
					href="{{ includeYield || includeScenarioYield ? yieldConfig['holdingsCommunication'] : yieldConfig['act33HoldingsCommunication'] }}"
					target="_top"
					(click)="onSendEmail()"
					class="email-link"
					custom-tracking
					track-event="pdf-logo-upload:include-yield:email-prospectuses"
				>
					<icon class="envelope" type="envelope"></icon>
					<span class="text-bold" dcrHTMLKey="PROSPECTUS_EMAIL_LINK_LABEL">Email Prospectuses</span>
				</a>
			</section>
		</section>
	</section>
</section>

<section *ngIf="showDisabledButtonAlert">
	<section class="warning-background">
		<section class="warning-head red"><icon class="message-icon" type="exclamation-circle"></icon></section>
		<span dcrHTMLKey="PROSPECTUS_EMAIL_ERROR_MESSAGE" class="warning-message text-14"> Please email the prospectus(es) to the client before generating the report. </span>
	</section>
</section>

<section *ngIf="showTooManyActFundsAlert">
	<section class="warning-background">
		<section class="warning-head red"><icon class="message-icon" type="exclamation-circle"></icon></section>
		<span dcrHTMLKey="PROSPECTUS_EMAIL_ACT33_ERROR_MESSAGE" class="warning-message text-14">
			Please consider including less 33 Act funds in the portfolio to generate an output.
		</span>
	</section>
</section>

<section *ngIf="showTooManyFundsAlert && (includeYield || includeScenarioYield)" class="padding-bottom-20">
	<section class="warning-background">
		<section class="warning-head red"><icon class="message-icon" type="exclamation-circle"></icon></section>
		<span dcrHTMLKey="PROSPECTUS_INVALID_EMAIL_ERROR_MESSAGE" class="warning-message text-14">
			Please consider including less funds in the portfolio to include yield in the output.
		</span>
	</section>
</section>

<section *ngIf="!yieldConfig && !hideYield">
	<section class="text-11">
		<div dcrHTMLKey="REPORT_YIELD_MESSAGE">Please note that the generated report will not show Yield due to regulatory reasons.</div>
		<div *ngIf="showPrivacyDisclaimer">
			<span dcrHTMLKey="PRIVACY_DISCLAIMER_PART_1"> BlackRock does not retain or use any information provided. Please read our </span>
			<a [href]="privacyUrl" dcrHTMLKey="PRIVACY_URL_LABEL" target="_blank">Data Privacy</a>
			<span dcrHTMLKey="PRIVACY_DISCLAIMER_PART_2"> rules here for further information.</span>
		</div>
	</section>
</section>
